import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions(
  {
    scheduleAppointment: ['startDateTime', 'appointmentType', 'donorSfid', 'numberOfChildren', 'centerSfid', 'createdFrom'],
    scheduleAppointmentLoading: null,
    scheduleAppointmentSuccess: ['res'],
    scheduleAppointmentFailure: ['error'],

    scheduleQuickAppointment: ['appointment'],
    scheduleQuickAppointmentLoading: null,
    scheduleQuickAppointmentSuccess: ['res'],
    scheduleQuickAppointmentFailure: ['error'],

    getAllAppointments: ['date', 'center'],
    getAllAppointmentsLoading: null,
    getAllAppointmentsSuccess: ['res'],
    getAllAppointmentsFailure: ['error'],

    getAppointment: ['id'],
    getAppointmentLoading: null,
    getAppointmentSuccess: ['res'],
    getAppointmentFailure: ['error'],

    rescheduleAppointment: ['id', 'appointment'],
    rescheduleAppointmentLoading: null,
    rescheduleAppointmentSuccess: ['res'],
    rescheduleAppointmentFailure: ['error'],

    cancelAppointment: ['id', 'cancelledFrom'],
    cancelAppointmentLoading: null,
    cancelAppointmentSuccess: ['res'],
    cancelAppointmentFailure: ['error'],

    /* NEW */

    getAvailableSlots: ['pdn', 'limit', 'appointmentType'],
    getAvailableSlotsLoading: null,
    getAvailableSlotsSuccess: ['res'],
    getAvailableSlotsFailure: ['error'],

    getBookedSlots: ['pdn', 'limit', 'appointmentType'],
    getBookedSlotsLoading: null,
    getBookedSlotsSuccess: ['res'],
    getBookedSlotsFailure: ['error'],

    createNewAppointment: ['appointment'],
    createNewAppointmentLoading: null,
    createNewAppointmentSuccess: ['res'],
    createNewAppointmentFailure: ['error'],

    validateAppointment: ['pdn', 'limit', 'appointmentType'],
    validateAppointmentLoading: null,
    validateAppointmentSuccess: ['res'],
    validateAppointmentFailure: ['error'],

    getUpcomingAppointments: ['donorSfid'],
    getUpcomingAppointmentsLoading: null,
    getUpcomingAppointmentsSuccess: ['res'],
    getUpcomingAppointmentsFailure: ['error'],

    newDonorBonusEligibility: null,
    newDonorBonusEligibilityLoading: null,
    newDonorBonusEligibilitySuccess: ['res'],
    newDonorBonusEligibilityFailure: ['error'],

    updateGiftCardPreference: ['giftCardPreference'],
    updateGiftCardPreferenceLoading: null,
    updateGiftCardPreferenceSuccess: ['res'],
    updateGiftCardPreferenceFailure: ['error'],
    
    cleanAppointmentState: null
  },
  { prefix: 'APPOINTMENTS_' }
)

export const AppointmentsTypes = Types

export default Creators
